import { render, staticRenderFns } from "./BppForm.vue?vue&type=template&id=2e18ef91&"
import script from "./BppForm.vue?vue&type=script&lang=js&"
export * from "./BppForm.vue?vue&type=script&lang=js&"
import style0 from "./BppForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports